module.exports = __webpack_public_path__ + "media/correct.ce420cc0.mp3";